import { RouteObject } from 'react-router-dom';
import { Roles } from '@/core/types';
import RolesGuard from '@/router/guards/RolesGuard';
import UsersPage from '@/views/pages/users';

export default [
	{
		path: 'users',
		element: (
			<RolesGuard roles={[Roles.LEVIANT_ADMIN, Roles.SITE_SUPERVISOR]} element={<UsersPage />} />
		),
	},
] as RouteObject[];
